import config from "./services/config";

// Badge colors: Optional color for the badge. May be one of:
//'blue', 'green', 'orange', 'red', 'yellow', 'purple', 'pink', 'sky', 'lime', 'light-gray'

class Icons {
    public static g(icon: string) {
        return config(undefined).getIconsBaseUrl() + icon;
    }

    static get AppIcon() {
        return Icons.g("app.png");
    }

    static Synced = class {
        public static get BadgeIcon() {
            return Icons.g("app.png");
        }
    };

    static Annotations = class {
        public static get BadgeIcon() {
            return Icons.g("tag2.svg");
        }
        public static readonly BgColor = "light-gray";
    };

    static Goal = class {
        public static get BadgeIcon() {
            return Icons.g("bullseye-arrow2.svg");
        }
    };

    static Step = class {
        public static get BadgeIcon() {
            return Icons.g("cubes2.svg");
        }
    };

    static Release = class {
        public static get BadgeIcon() {
            return Icons.g("flag-checkered2.svg");
        }
    };

    static Estimation = class {
        public static get BadgeIcon() {
            return Icons.g("product-hunt.svg");
        }
        public static readonly BgColorLargeStory = "yellow";
    };

    static CardBack = class {
        public static get BadgeIcon() {
            return Icons.g("app.png");
        }
    };
}

export default Icons;
